.signet-tabs {
  display: flex;

  .tab-list {
    display: flex;
    background-color: transparent;
    padding: 0;
    margin: 0;

    &.justify-justified {
      .tab-item {
        width: 100%;
        text-align: center;
      }
    }
    .tab-item {
      cursor: pointer;
      text-decoration: none;
      white-space: nowrap;
      background-color: transparent;
      vertical-align: inherit;
      border: 0;
      border-bottom: 2px solid;
      border-color: transparent;
      color: var(--left-nav-element-element-default);
      border-radius: 0;
      transition: all 0.3s ease-in-out;
      position: relative;
      text-transform: capitalize;
      font-family: 'Lato';
      font-style: normal;
      font-weight: 600;
      font-size: 13px;
      line-height: 150%;
      overflow: hidden;


      :hover {
        text-decoration: none;
      }

      // &[aria-selected='true'] {
      //   color: var(--left-nav-element-element-selected);
      //   border-bottom: 2px solid var(--action-default) !important;
      //   transition: all 0.3s ease-in-out;
      // }

      span.ripple {
        position: absolute;
        border-radius: 50%;
        transform: scale(0);
        animation: ripple 600ms linear;
        background-color: rgba(255, 255, 255, 0.8);
      }

      @keyframes ripple {
        to {
          transform: scale(4);
          opacity: 0;
        }
      }
    }
  }

  .tab-panel {
    width: 100%;
    white-space: normal;
    padding: 16px;
  }

  &.outlined {
    .tab-list {
      .tab-item {
        padding: 12px 16px;

        &[aria-selected='true'] {
          color: var(--left-nav-element-element-selected);
          border-bottom: 2px solid var(--action-default) !important;
          transition: all 0.3s ease-in-out;
        }
      }
    }
  }

  &.filled {
    .tab-list {
      border: 1px solid var(--gray-100);
      width: fit-content;
      border-radius: 4px;

      .tab-item {
        padding: 8px 24px;

        &[aria-selected='true'] {
          color: var(--primary-main);
          transition: all 0.3s ease-in-out;
          background-color: rgba(0, 97, 55, 0.3);
          border-bottom: 0;
        }
      }
    }
  }

  &.align {
    &-top {
      flex-direction: column;

      .tab-list {
        flex-wrap: wrap;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;

        &.justify-justified {
          flex-wrap: nowrap;
        }

        .tab-item {
          &[aria-selected='true'] {
            border-bottom: 0;
            border-top-right-radius: 4px;
            border-top-left-radius: 4px;
          }
        }
      }

      .tab-panel {
        flex-shrink: 0;
        border-top: 0;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }

    &-bottom {
      flex-direction: column-reverse;

      .tab-list {
        flex-wrap: wrap;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;

        &.justify-justified {
          flex-wrap: nowrap;
        }

        .tab-item {
          &[aria-selected='true'] {
            position: relative;
            border-top: 0;
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
          }
        }
      }

      .tab-panel {
        flex-shrink: 0;
        border-bottom: 0;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
      }
    }

    &-left {
      flex-direction: row;

      .tab-list {
        flex-direction: column;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;

        &.justify-justified {
          .tab-item {
            height: 100%;
          }
        }

        .tab-item {
          align-self: flex-end;
          width: 100%;
          margin-right: -2px;

          width: 101%;

          &[aria-selected='true'] {
            box-shadow: 0 3px 5px rgba(0, 0, 0, 0.15),
              0 2px 4px rgba(0, 0, 0, 0.12);
            border-right: 0;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
          }
        }
      }

      .tab-panel {
        border-left: 0;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }

    &-right {
      flex-direction: row-reverse;

      .tab-list {
        flex-direction: column;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;

        &.justify-justified {
          .tab-item {
            height: 100%;
          }
        }

        .tab-item {
          align-self: flex-start;
          width: 100%;

          width: 101%;

          &[aria-selected='true'] {
            box-shadow: 0 3px 5px rgba(0, 0, 0, 0.15),
              0 2px 4px rgba(0, 0, 0, 0.12);
            border-left: 0;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
          }
        }
      }

      .tab-panel {
        border-right: 0;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
    }
  }
}
